import React from "react";
import {
  FaShieldAlt,
  FaHandHoldingUsd,
  FaShippingFast,
  FaUsers,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Button from "../../components/common/Button/Button";
import HeroSection from "../../components/heros/HeroSection";
import BenefitCard from "../../components/partner/BenefitCard/BenefitCard";

import "./SellersPage.css";
import herosellerimage from "../../assets/hero-seller.png";
import ProcessCard from "../../components/partner/ProcessStepCard/ProcessStepCard";
import TestimonialCard from "../../components/partner/TestimonialCard/TestimonialCard";

import FinaCta from "../../components/partner/SellerCta/FinalCtaSection";

const heroData = {
    titleLine1: "Become a Seller",
    titleLine2: "on Vanidya",
    subtitle:
        "Join a unique marketplace for Satvik groceries, organic essentials, pooja items, and spiritual books. Grow your business and connect with mindful customers who value trust, quality, and transparency.",
    ctaText: "Start Your Seller Journey",
    backgroundImageUrl: "/images/seller-hero.jpg",
};

const benefitsData = [
    {
        icon: <FaShieldAlt />,
        title: "Verified Seller Platform",
        description:
            "Get recognized as a trusted seller—every business is reviewed for quality, purity, and transparency.",
    },
    {
        icon: <FaHandHoldingUsd />,
        title: "No Platform Fees",
        description:
            "Keep what you earn. Enjoy direct, transparent payments—no hidden deductions.",
    },
    {
        icon: <FaShippingFast />,
        title: "Local, Fast Fulfillment",
        description:
            "Deliver to your area on your terms—build customer loyalty with prompt, reliable service.",
    },
    {
        icon: <FaUsers />,
        title: "Reach Mindful Customers",
        description:
            "Grow your business with buyers who care about authenticity, ingredient clarity, and Satvik values.",
    },
];

const processStepsData = [
    {
        stepNumber: 1,
        title: "Register & Get Approved",
        titleColor: "#DF8D44",
        descriptionPoints: [
            "Fill out our seller application and provide basic KYC documentation.",
            "Your business and products are reviewed for compliance with Vanidya standards.",
            "Complete a simple onboarding and agreement.",
        ],
    },
    {
        stepNumber: 2,
        title: "Add Your Products",
        titleColor: "#DF8D44",
        descriptionPoints: [
            "List Satvik, organic, and pooja essentials with details, images, and certifications as needed.",
            "Set your pricing, minimum order values, and local delivery areas.",
            "Follow transparent labelling and product info guidelines.",
        ],
    },
    {
        stepNumber: 3,
        title: "Start Selling & Delivering",
        titleColor: "#DF8D44",
        descriptionPoints: [
            "Receive and manage orders via your dashboard.",
            "Fulfill orders quickly and build your seller reputation.",
            "Payments come directly to you—grow your business and reach new customers.",
        ],
    },
];

const testimonialsData = [
  {
    quote:
      "Since joining Vanidya, we reach more devotees daily and our business is now directly contributing to community welfare. Payments are instant, and we control our delivery.",
    author: "Radha Foods, Chennai",
    imageUrl: "/images/user1.jpg",
  },
  {
    quote:
      "We no longer have to pay huge fees to big platforms. Vanidya gives us trusted leads, and our partnership brings in more repeat customers.",
    author: "Srinivasa Kirana, Hyderabad",
    imageUrl: "/images/user2.jpg",
  },

  {
    quote:
      "The platform tools are intuitive, and the Vanidya team provides exceptional support. It’s a partnership that feels genuinely collaborative.",
    author: "Sai Provisions, Mumbai",
    imageUrl: "/images/user3.jpg",
  },
];

const ForSellersPage = () => {
  const handleScrollToOnboarding = () => {
    document
      .getElementById("onboarding-section")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="for-sellers-page">
      <HeroSection
        titleLine1={heroData.titleLine1}
        titleLine2={heroData.titleLine2}
        subtitle={heroData.subtitle}
        ctaText={heroData.ctaText}
        onCtaClick={handleScrollToOnboarding}
        backgroundImageUrl={herosellerimage}
      />

      <section
        className="page-section benefits-section_"
        style={{ marginTop: "6rem" }}
      >
        <h2 className=" _hTitle_s5E_ section-title">The Vanidya Advantage</h2>
        <p className=" workflow-subtitle _hSubtitle_t6F_ ">
          Join a platform dedicated to quality, trust, and the success of its
          partners.
        </p>
        <div className="benefits-flex-container" style={{ paddingTop: "0px" }}>
          {benefitsData.map((benefit, index) => (
            <BenefitCard
              key={benefit.title}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
              animationDelay={0.1 + index * 0.15}
            />
          ))}
        </div>
      </section>

      <section id="onboarding-section" className="how-it-works-section">
        <h2 className="_hTitle_s5E_ section-title">How to Start Selling</h2>
        <p className=" workflow-subtitle _hSubtitle_t6F_">
          Joining our collective is a straightforward and rewarding experience.
        </p>
        <div className="process-steps-grid" style={{ paddingTop: "0px" }}>
          {processStepsData.map((step) => (
            <ProcessCard
              key={step.title}
              stepNumber={step.stepNumber}
              title={step.title}
              descriptionPoints={step.descriptionPoints}
              titleColor={step.titleColor}
            />
          ))}
        </div>
      </section>

      {/*<section className="page-section testimonials-section">
        <h2 className="_hTitle_s5E_ section-title">Seller Stories</h2>
        <p className="_hSubtitle_t6F_ section-subtitle">
          Hear from talented sellers thriving within our curated community.
        </p>
        <div className="testimonials-grid" style={{ paddingTop: "0px" }}>
          {testimonialsData.map((testimonial, index) => (
            <TestimonialCard
              key={testimonial.author}
              testimonial={testimonial}
              animationDelay={0.1 + index * 0.15}
            />
          ))}
        </div>
      </section>*/}

      <FinaCta />
    </div>
  );
};

export default ForSellersPage;
